import { ArrowsRightLeftIcon, TrashIcon, XMarkIcon } from "@heroicons/react/20/solid";
import _ from 'lodash';
import { connect } from 'react-redux';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";

const TransferCreditToAdvisorModal = ({
    isTransferModalOpen,
    closeModal,
    org,
    transferCreditsToAdvisor,
    voidCredits,
    totalCreditValue,
    isVoidCreditsModalOpen,
    selectedCredits,
    isVoidAdvisorCreditsModalOpen,
    totalAdvisorCreditsValue,
    advisorName,
    voidAdvisorCredits,
}) => {

    if (isTransferModalOpen) {

        return (
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true"
                 style={{display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto"}}>
                <div className="modal-dialog"
                     style={{width: "600px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)"}}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b"
                             style={{paddingBottom: 60}}>
                            <div className="block-header bg-primary-dark" style={{padding: 20}}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon
                                            className="h-6 w-6 mr-3 text-white"/></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Transfer {totalCreditValue} Credits
                                    From {org?.businessDetails.name} to {org?.advisorDetails?.name}</h3>
                            </div>
                        </div>
                        <div className="block-content" style={{padding: 20}}>
                            <h3 className="block-title">Transfer {totalCreditValue} Credits
                                From {org?.businessDetails.name} to {org?.advisorDetails?.name}</h3>
                        </div>
                        <button
                            className="btn btn-success pull-right"
                            type="button"
                            style={{marginRight: 25, marginTop: 20, marginBottom: 20}}
                            onClick={transferCreditsToAdvisor}
                        >
                            <ArrowsRightLeftIcon style={{height: "1.5em", float: "left", marginRight: 5}}/>
                            <div style={{float: "left"}}>Transfer Credits</div>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }

    if (isVoidCreditsModalOpen) {
        return (
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true"
                 style={{display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto"}}>
                <div className="modal-dialog"
                     style={{width: "600px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)"}}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b"
                             style={{paddingBottom: 60}}>
                            <div className="block-header bg-primary-dark" style={{padding: 20}}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon
                                            className="h-6 w-6 mr-3 text-white"/></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Void {totalCreditValue} Credits from {org?.businessDetails.name}</h3>
                            </div>
                        </div>
                        <div className="block-content" style={{padding: 20}}>
                            <h3 className="block-title">Void {totalCreditValue} Credits from {org?.businessDetails.name}</h3>
                        </div>
                        <button
                            className="btn btn-danger pull-right"
                            type="button"
                            style={{marginRight: 25, marginTop: 20, marginBottom: 20}}
                            onClick={voidCredits}
                        >
                            <TrashIcon style={{height: "1.5em", float: "left", marginRight: 5}}/>
                            <div style={{float: "left"}}>Void Credits</div>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }

    if (isVoidAdvisorCreditsModalOpen) {
        return (
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true"
                 style={{display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto"}}>
                <div className="modal-dialog"
                     style={{width: "600px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)"}}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b"
                             style={{paddingBottom: 60}}>
                            <div className="block-header bg-primary-dark" style={{padding: 20}}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon
                                            className="h-6 w-6 mr-3 text-white"/></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Void {totalAdvisorCreditsValue} Credits from {advisorName}</h3>
                            </div>
                        </div>
                        <div className="block-content" style={{padding: 20}}>
                            <h3 className="block-title">Void {totalAdvisorCreditsValue} Credits from {advisorName}</h3>
                        </div>
                        <button
                            className="btn btn-danger pull-right"
                            type="button"
                            style={{marginRight: 25, marginTop: 20, marginBottom: 20}}
                            onClick={voidAdvisorCredits}
                        >
                            <TrashIcon style={{height: "1.5em", float: "left", marginRight: 5}}/>
                            <div style={{float: "left"}}>Void Credits</div>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }

    return null
}

const mapStateToProps = (state, ownProps) => {

    const selectedCredits = state?.payment?.credits?.filter(c => c.selected)
    const advisorCredits = state?.advisor.credits?.filter(c => c.selected);

    return {
        isTransferModalOpen: state?.company?.billingModal == "TransferCreditsToAdvisor",
        isVoidCreditsModalOpen: state?.company?.billingModal == "VoidCredits",
        isVoidAdvisorCreditsModalOpen: state?.company?.billingModal == "VoidAdvisorCredits",
        org: state?.payment?.stats,
        selectedCredits: selectedCredits,
        totalCreditValue: _.sumBy(selectedCredits, 'credits'),
        totalAdvisorCreditsValue: _.sumBy(advisorCredits, 'credits'),
        advisorName: state?.advisors?.settings?.name,
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(COMPANYACTIONS.setBillingModal()),
    transferCreditsToAdvisor: () => dispatch(PAYMENTACTIONS.transferCreditsToAdvisor()),
    voidCredits: () => dispatch(PAYMENTACTIONS.voidCredits()),
    voidAdvisorCredits: () => dispatch(PAYMENTACTIONS.voidAdvisorCredits()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransferCreditToAdvisorModal)